<template>
  <div>
    <div class="content-item" v-for="(item, idx) in print" :key="idx">
      <div class="row mt-2">
        <div class="col-12 text-center">
          <h3>勞工健康服務執行紀錄表</h3>
        </div>
        <div class="col-12 text-right service-date">
          <template v-if="item.serviceDate">
            <p>執行日期：{{ item.serviceDate.serviceDate.year === `` ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;` : item.serviceDate.serviceDate.year }}年
              {{ item.serviceDate.serviceDate.month === `` ? `&nbsp;&nbsp;` :item.serviceDate.serviceDate.month.padStart(2, '0') }}月
              {{ item.serviceDate.serviceDate.day === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.day.padStart(2, '0') }}日</p>
            <p>時間：{{ item.serviceDate.serviceDate.startTime.hour === ``? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.startTime.hour.padStart(2, '0') }}時
              {{ item.serviceDate.serviceDate.startTime.minute === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.startTime.minute.padStart(2, '0') }}分迄
              {{ item.serviceDate.serviceDate.endTime.hour === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.endTime.hour.padStart(2, '0') }}時
              {{ item.serviceDate.serviceDate.endTime.minute === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.endTime.minute.padStart(2, '0') }}分</p>
          </template>
        </div>
        <div class="col-12 outline-border p-0">
          <div class="outline-bottom">
            <p>一、作業場所基本資料</p>
          </div>
          <div class="outline-bottom">
            <p>事業單位名稱：{{ item.baseInfo.locationName }}</p>
          </div>
          <div class="outline-bottom">
            <p>事業單位地址：{{ item.baseInfo.locationAddress }}</p>
          </div>
          <div class="outline-bottom">
            <p>部門名稱：{{ item.baseInfo.departmentName }}</p>
          </div>
          <div class="outline-bottom workers-field">
            <div class="row p-0">
              <div class="col title">
                <p>作業人員</p>
              </div>
              <div class="col content">
                <p>
                  <span v-if="item.baseInfo.administrationStaff.male + item.baseInfo.administrationStaff.female > 0">■ </span>
                  <span v-else>□ </span>
                  行政人員：
                  男 <span class="number-field">{{ item.baseInfo.administrationStaff.male }}</span> 人；
                  女 <span class="number-field">{{ item.baseInfo.administrationStaff.female }}</span> 人
                </p>
                <p>
                  <span v-if="item.baseInfo.fieldOperator.male + item.baseInfo.fieldOperator.female > 0">■ </span>
                  <span v-else>□ </span>
                  現場操作人員：
                  男 <span class="number-field">{{ item.baseInfo.fieldOperator.male }}</span> 人；
                  女 <span class="number-field">{{ item.baseInfo.fieldOperator.female }}</span> 人
                </p>
              </div>
            </div>
          </div>
          <div class="workers-field">
            <div class="row p-0">
              <div class="col title">
                <p>作業類別與人數</p>
              </div>
              <div class="col content">
                <p>
                  <span v-if="item.baseInfo.workers.generalWorker > 0">■ </span>
                  <span v-else>□ </span>
                  一般作業：人數：<span class="number-field">{{ item.baseInfo.workers.generalWorker }}</span>人</p>
                <p>
                  <span v-if="item.baseInfo.workers.hazardousWork > 0">■ </span>
                  <span v-else>□ </span>
                  特別危害健康作業：<span class="number-field">{{ item.baseInfo.workers.hazardousWork }}</span>人</p>
                <p>類別:</p>
                <div v-for="(category, categoryIdx) in item.baseInfo.categorySelections" :key="categoryIdx">
                  <p class="category-item">{{ category.name }}：<span class="number-field">{{ category.counter }}</span> 人數</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 outline-border p-0">
          <p>二、作業場所與勞動條件概況：工作流程（製程）、工作型態與時間、人員及危害特性概述</p>
          <p class="line-break">{{ item.laborCondition }}</p>
        </div>
        <div class="col-12 outline-border p-0">
          <div>
            <p>三、臨場健康服務執行情形（包含辦理事項、發現問題）（本規則第九條至第十三條事項）：</p>
            <div class="row p-0">
              <div class="col-12 mb-1">
                <p>(一)辦理事項</p>
                <div v-for="(option, optionIdx) in item.serviceSummary.options" :key="optionIdx">
                  <div v-if="showServiceSummary(option)">
                    <p>
                      <span v-if="checkServiceSummaryOption(option)">■</span>
                      <span v-else>□</span>
                      {{ option.id }} {{ getServiceSummaryWording(option) }}
                      <span v-if="!isNaN(Number(option.value))">
                        共
                        <span v-if="option.value" class="number-field">{{ option.value }}</span>
                        <span v-else>_____</span>
                        名。
                      </span>
                    </p>
                    <div v-for="(optionChildren, optionChildrenIdx) in option.children" :key="optionChildrenIdx">
                      <p style="padding-left: 20pt" v-if="showServiceSummaryChildren(optionChildren)">
                        <span v-if="optionChildren">■</span>
                        <span v-else>□</span>
                        {{ getServiceSummaryChildrenWording(optionChildrenIdx) }}
                        <span v-if="optionChildrenIdx === 8 && !!optionChildren">
                          <span v-if="option.otherValue">{{ option.otherValue }}</span>
                          <span v-else>_____</span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 mb-4">
                <p>(二) 發現問題</p>
                <p class="line-break">{{ item.serviceSummary.problemFound }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 outline-border p-0">
          <p>四、本次臨場服務結果、改善及建議採行措施（針對發現問題所採行之措施）：</p>
          <p class="line-break mb-2">{{ item.improvementMeasures }}</p>
        </div>
        <div class="col-12 outline-border p-0">
          <p>五、對於前次建議改善事項之追蹤辦理情形：</p>
          <p class="line-break mb-2">{{ item.previousServiceProgress }}</p>
        </div>
        <div class="col-12 outline-border p-0">
          <p>六、執行人員及日期(僅就當次實際執行者簽章)</p>
        </div>
        <div class="col-12 outline-border p-0">
          <div class="row p-0 signatures">
            <div class="col-6">
              <p class="print-line-height">□勞工健康服務之醫師，簽章
                <img v-if="checkSignatureIsValid(item.serviceDate.doctorSignature)"
                     class="d-block"
                     :src="item.serviceDate.doctorSignature.eSignature" alt="eSignature" />
                <span v-else>____________</span>
              </p>
              <p class="print-line-height">□勞工健康服務之護理人員，簽章
                <img v-if="checkSignatureIsValid(item.serviceDate.nurseSignature)"
                     class="d-block"
                     :src="item.serviceDate.nurseSignature.eSignature" alt="eSignature" />
                <span v-else>____________</span>
              </p>
              <p class="print-line-height">□勞工健康服務之相關人員，簽章
                <img v-if="checkSignatureIsValid(item.serviceDate.relatedWorker)"
                     class="d-block"
                     :src="item.serviceDate.relatedWorker.eSignature" alt="eSignature" />
                <span v-else>____________</span>
              </p>
              <p class="print-line-height">□專任負責人或代理人，簽章
                <img v-if="checkSignatureIsValid(item.serviceDate.projectManagerSignature)"
                     class="d-block"
                     :src="item.serviceDate.projectManagerSignature.eSignature" alt="eSignature" />
                <span v-else>____________</span>
              </p>
            </div>
            <div class="col-6 outline-left">

              <p class="mb-1 print-line-height">□事業單位配合人員，簽章
                <span v-if="item.serviceDate.businessUnit && item.serviceDate.businessUnit!==''"
                      class="print-signature-block d-block color-black pl-2">{{item.serviceDate.businessUnit}}</span>
                <span v-else class="print-signature-block d-block">____________</span>
              </p>
              <p class="mb-1 print-line-height">□職業安全衛生管理人員，簽章
                <span v-if="item.serviceDate.healthcareManager && item.serviceDate.healthcareManager!==''"
                      class="print-signature-block d-block color-black pl-2">{{item.serviceDate.healthcareManager}}</span>
                <span v-else class="print-signature-block d-block">____________</span>
              </p>
              <p class="mb-1 print-line-height">□人力資源管理人員，簽章
                <span v-if="item.serviceDate.hrManager && item.serviceDate.hrManager!==''"
                      class="print-signature-block d-block color-black pl-2">{{item.serviceDate.hrManager}}</span>
                <span v-else class="print-signature-block d-block">____________</span>
              </p>
              <p class="mb-1 print-line-height">部門名稱
                <span v-if="item.serviceDate.departmentName!==''"
                      class="print-signature-block color-black pl-2">{{ item.serviceDate.departmentName }}</span>
                <span v-else class="print-signature-block">______</span>
              </p>
              <p class="mb-1 print-line-height">
                主管職稱
                <span v-if="item.serviceDate.departmentName!==''"
                      class="print-signature-block color-black pl-2">{{ item.serviceDate.jobTitle }}</span>
                <span v-else class="print-signature-block">_______</span>
              </p>
              <p class="mb-1 print-line-height">簽章<span class="print-signature-block">____________</span></p>
            </div>
          </div>
        </div>
        <div class="col-12 outline-border p-0 text-right">
          <div class="outline-bottom">
            <p>執行日期：{{ item.serviceDate.serviceDate.year === `` ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;` : item.serviceDate.serviceDate.year }}年
              {{ item.serviceDate.serviceDate.month === `` ? `&nbsp;&nbsp;` :item.serviceDate.serviceDate.month.padStart(2, '0') }}月
              {{ item.serviceDate.serviceDate.day === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.day.padStart(2, '0') }}日</p>
            <p>時間：{{ item.serviceDate.serviceDate.startTime.hour === ``? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.startTime.hour.padStart(2, '0') }}時
              {{ item.serviceDate.serviceDate.startTime.minute === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.startTime.minute.padStart(2, '0') }}分迄
              {{ item.serviceDate.serviceDate.endTime.hour === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.endTime.hour.padStart(2, '0') }}時
              {{ item.serviceDate.serviceDate.endTime.minute === `` ? `&nbsp;&nbsp;` : item.serviceDate.serviceDate.endTime.minute.padStart(2, '0') }}分</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: mapServiceRecordSheetGetters } = createNamespacedHelpers('serviceRecordSheet');

export default {
  name: 'ServiceRecordSheet',
  computed: {
    ...mapServiceRecordSheetGetters(['print', 'printWithDetail']),
  },
  data() {
    return {
      serviceSummaryWording: [
        {
          id: '9-1',
          wording: '勞工體格（健康）檢查結果之分析與評估、健康管理及資料保存。',
        },
        {
          id: '9-2',
          wording: '協助雇主選配勞工從事適當之工作，',
        },
        {
          id: '9-3',
          wording: '辦理健康檢查結果異常者之追蹤管理及健康指導，',
        },
        {
          id: '9-4',
          wording: '辦理未滿十八歲勞工、有母性健康危害之虞之勞工、職業傷病勞工與職業健康相關高風險勞工之評估及個案管理，',
        },
        {
          id: '9-5',
          wording: '職業衛生或職業健康之相關研究報告及傷害、疾病紀錄之保存。',
        },
        {
          id: '9-6',
          wording: '勞工之健康教育、衛生指導、身心健康保護、健康促進等措施之策劃及實施。',
        },
        {
          id: '9-7',
          wording: '工作相關傷病之預防、健康諮詢與急救及緊急處置，',
        },
        {
          id: '9-8',
          wording: '定期向雇主報告及勞工健康服務之建議。',
        },
        {
          id: '11-1',
          wording: '辨識與評估工作場所環境、作業及組織內部影響勞工身心健康之危害因子，並提出改善措施之建議。',
        },
        {
          id: '11-2',
          wording: '提出作業環境安全衛生設施改善規劃之建議。',
        },
        {
          id: '11-3',
          wording: '調查勞工健康情形與作業之關連性，並採取必要之預防及健康促進措施。',
        },
        {
          id: '11-4',
          wording: '提供復工勞工之職能評估、職務再設計或調整之諮詢及建議。',
        },
        {
          id: '11-5',
          wording: '其他經中央主管機關指定公告者。',
          children: [
            '人因性危害預防計劃。',
            '異常工作負荷促發疾病預防計劃。',
            '工作場所母性健康保護計劃。',
            '執行職務遭受不法侵害預防計畫。',
            '呼吸防護計劃。',
            '防疫措施之策劃及實施。',
            '訂定勞工健康服務計畫，據以執行，每年評估成效及檢討。',
            '訂定勞工健康管理方案，據以辦理，每年評估成效及檢討。',
            '其他：',
          ],
        },
      ],
    };
  },
  methods: {
    showServiceSummary(serviceSummaryOption) {
      if (serviceSummaryOption.children) {
        return serviceSummaryOption.children.find(item => item === true) || this.printWithDetail;
      }
      return serviceSummaryOption.checked || this.printWithDetail;
    },
    showServiceSummaryChildren(childrenOption) {
      return childrenOption || this.printWithDetail;
    },
    checkServiceSummaryOption(serviceSummaryOption) {
      if (serviceSummaryOption.children) {
        return serviceSummaryOption.children.find(item => item === true);
      }
      return serviceSummaryOption.checked;
    },
    getServiceSummaryWording(serviceSummaryOption) {
      const data = this.serviceSummaryWording.find(item => item.id === serviceSummaryOption.id);
      return data.wording;
    },
    getServiceSummaryChildrenWording(idx) {
      const data = this.serviceSummaryWording.find(item => item.id === '11-5');
      return data.children[idx];
    },
    checkSignatureIsValid(signatureData) {
      if (!signatureData){
        return false;
      }

      return signatureData.eSignature.indexOf('data:image/png;base64') >=0
    }
  },
  mounted() {
    setTimeout(() => {
      window.print();
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
.content-item {
  padding-left: 15pt;
  padding-right: 15pt;
}
p {
  margin-bottom: 0;
}
.outline-border {
  border-top: 0.5pt solid black;
  border-right: 0.5pt solid black;
  border-left: 0.5pt solid black;
  p {
    padding-left: 10pt;
  }
}
.outline-bottom {
  border-bottom: 0.5pt solid black;
}
.outline-left {
  border-left: 0.5pt solid black;
}

.workers-field {
  .title {
    width: 120px;
    height: 50px;
    flex: 0 0 135pt !important;
    max-width: 135pt !important;
  }
  .content {
    border-left: 0.5pt solid black;
    margin-bottom: 2pt;
  }
  .category-item {
    margin-left: 10pt;
  }
}
.signatures {
  img {
    width: 120px;
    margin-bottom: 5pt;
  }
}

.number-field {
  border-bottom: 0.5pt solid black;
  min-width: 35pt;
  text-align: center;
  display: inline-block;
}

.line-break {
  white-space: pre-line;
}

@media print {
  .content-item {
    page-break-after: always;
    padding-left: 15pt;
    padding-right: 15pt;
  }
  .content-item:last-child {
    page-break-after: auto;
  }
  p {
    margin-bottom: 0;
    font-size: 18pt;
  }
  h3 {
    font-size: 28pt;
  }
  .service-date {
    font-size: 14pt;
  }
  .outline-border {
    border-top: 0.5pt solid black;
    border-right: 0.5pt solid black;
    border-left: 0.5pt solid black;
    p {
      padding-left: 10pt;
    }
  }
  .outline-bottom {
    border-bottom: 0.5pt solid black;
  }
  .outline-left {
    border-left: 0.5pt solid black;
  }

  .workers-field {
    .title {
      width: 120px;
      height: 50px;
      flex: 0 0 135pt !important;
      max-width: 135pt !important;
    }
    .content {
      border-left: 0.5pt solid black;
      margin-bottom: 2pt;
    }
    .category-item {
      margin-left: 10pt;
    }
  }
  .signatures {
    page-break-inside: avoid;
    img {
      width: 120px;
      margin-top: 5pt;
      margin-bottom: 5pt;
    }
  }
  .print-line-height {
    line-height: 1.5cm;
    min-height: 64px;
    img {
      border-bottom: black 1.5px solid;
    }
  }
  .print-signature-block {
    color: rgba(0, 0, 0, 0);
    border-bottom: black 1.5px solid;
    display: inline-block;
    width: 40%;
  }
  .color-black {
    color: black !important;
  }
}
</style>
